import { Component, Inject, NgZone } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "custom-dialog",
  templateUrl: "./custom-dialog.component.html",
  styleUrls: ["./custom-dialog.component.scss"],
  standalone: false,
})
export class CustomDialogComponent {
  public isFullscreenLoaderShown: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ngZone: NgZone,
    public dialogRef: MatDialogRef<CustomDialogComponent>,
  ) {}

  closeCustomDialog() {
    this.isFullscreenLoaderShown = this.data.type === "gallery";
    this.ngZone.run(() => {
      this.dialogRef.close();
      this.isFullscreenLoaderShown = false;
    });
  }
}
